import { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  convertDateFormatCalendar,
  convertTZToDate,
  exportToExcel,
  generateDropdownOptions,
} from '../../../utility/genricFunction'
import * as Yup from 'yup'
import { VALIDATION_MESSAGES } from '../../../utility/constantValidationMessages'
import { ROUTES_PATH } from '../../../utility/constants'
import { ErrorMessage, Form, Formik } from 'formik'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import Button from '../../../components/button/Button'
import Calendar from '../../../components/calendar/Calendar'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import './facultyLactureReport.scss'
import { getFacultyLectureReport } from '../../../store/builders/reports/reports.builder'
import PrintIcon from '@mui/icons-material/Print';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'

function FacultyLectureReport() {
  const dispatch = useDispatch()

  const facultyReportData = useSelector((store) => store.reports.facultyLectureReportData)
  const loading = useSelector((store) => store.reports.loading)

  const branches = useSelector((state) => state?.branch?.branchTableData)
  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

  const userRole = useSelector((state) => state.auth?.user?.result?.userData?.roleName) || {}
  const branchId = useSelector((state) => state.auth?.user?.result?.userData?.branchId)

  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [isTableOpen, setIsTableOpen] = useState(false)

  const [initialValues] = useState({
    fromDate: '',
    toDate: '',
    branch: userRole == "branch" ? branchId : '',
  })

  useEffect(() => {
    // dispatch(getBranch('active'))
  }, [])

  const validationSchema = Yup.object().shape({
    fromDate: Yup.string().required(VALIDATION_MESSAGES.DATE),
    toDate: Yup.string().required(VALIDATION_MESSAGES.DATE),
    branch: Yup.string().required(VALIDATION_MESSAGES.BRANCH_FORM.BRANCH_NAME_REQUIRED),
  })

  function handleFormSubmit(values) {
    setFromDate(values.fromDate)
    setToDate(values.toDate)
    // setIsTableOpen(true)

    const data = {
      fromDate: values.fromDate,
      toDate: values.toDate,
      branch: values.branch,
    }

    dispatch(getFacultyLectureReport({ data, setIsTableOpen }))
  }

  const breadCrumbsArr = [
    {
      title: 'Faculty Lecture report',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: 'New Branch',
      link: ROUTES_PATH.FACULTY_LECTURE_REPORT,
    },
  ]

  const dateBody = (reportData) => {
    const representative = reportData?.date && convertTZToDate(reportData?.date)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const typeBody = (reportData) => {
    const representative = reportData?.type && reportData?.type?.split("_").join(" ")
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const columns = [
    {
      field: 'no',
      header: '#',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
    {
      field: 'date',
      header: 'Date',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      body: dateBody
    },
    {
      field: 'classTime',
      header: 'Classtime',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
    {
      field: 'batch',
      header: 'Batch',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
    {
      field: 'type',
      header: 'Lecture/Exam',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      body: typeBody
    },
    {
      field: 'moduleName',
      header: 'Module',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
  ]

  const printRef = useRef()

  const handleDownloadPfd = useReactToPrint({
    content: () => printRef.current,
    copyStyles: true
  });

  return (
    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> && <div className='facultyLactureReport-wrapper'>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleFormSubmit(values)
        }}
        enableReinitialize
      >
        {({ values, handleChange, handleSubmit, setFieldValue }) => (
          <Form>
            <div className='facultyLactureReport-header'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            </div>

            <div className='facultyLactureReport'>
              <div className='facultyLactureReport-input-fields'>
                <Calendar
                  label='From Date'
                  name='fromDate'
                  width={'100%'}
                  required={true}
                  value={values?.rateEffectiveDate}
                  onChange={(values) => setFieldValue('fromDate', convertDateFormatCalendar(values))}
                />

                <Calendar
                  label='To Date'
                  name='toDate'
                  width={'100%'}
                  required={true}
                  value={values?.rateEffectiveDate}
                  onChange={(values) => setFieldValue('toDate', convertDateFormatCalendar(values))}
                />

                <div className='facultyLactureReport-input'>
                  <label htmlFor=''>
                    Branch<span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    options={branchOption}
                    selectedValue={values?.branch}
                    className={'facultyLactureReport-dropdown'}
                    onChange={handleChange}
                    name={'branch'}
                    placeholder={'Select Branch'}
                    disabled={userRole == "branch"}
                  />
                  <ErrorMessage name='branch' component='div' className='error-msg' />
                </div>
              </div>

              <div className='report-submit-div'>
                <Button customClassName={'save-btn'} onClick={handleSubmit}>
                  Submit
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>

      {isTableOpen && (
        <div className='facultyLactureReport-table'>
          <div className='export-option-wrapper'>
            <div className='pdf-excel-export'>
              <Button
                text={'Export'}
                type={'button'}
                onClick={() =>
                  exportToExcel(facultyReportData, columns, 'Faculty Lecture Report', 'FacultyLectureReport.xlsx')
                } // Export button
                disabled={facultyReportData?.length > 0 ? false : true}
              ><SimCardDownloadIcon /></Button>
              <Button
                text={'Export'}
                type={'button'}
                onClick={handleDownloadPfd}
                disabled={facultyReportData?.length > 0 ? false : true}
              ><PrintIcon /></Button>
            </div>

          </div>

          <div ref={printRef} className='printable-component'>
            {facultyReportData.length > 0 ?

              facultyReportData?.map((faculty) => {
                return (
                  <>
                    <div className='report-heading-label-div'>{faculty?.facultyName}</div>
                    <ReportDataTable columns={columns} value={faculty?.data}  />
                  </>
                )
              })
              : <ReportDataTable columns={columns} value={[]} />
            }
          </div>

        </div>
      )}
    </div>}
    </>
  )
}

export default FacultyLectureReport
